@switch (view) {
    @case ('Pair') {
        <ms-inline-tooltip>
            <div class="participants-pair-game">
                @for (participantInfo of participantInfos; track $index) {
                    <div class="participant-wrapper" [class.image]="showParticipantImage">
                        <div class="participant-container">
                            @if (participantInfo.isSingleContestant && enableImages) {
                                <ms-participant-image
                                    [sportId]="event.sport.id"
                                    [participantImage]="participantInfo.participant.image"
                                    [showLogoColor]="showLogoColor" />
                            }
                            <ng-template #participant>
                                @if (!participantInfo.rank && !participantInfo.winLossStats && !participantInfo.pitcher) {
                                    <div #tooltipContent class="participant" [class.highlight]="shouldHighlight(participantInfo.participant)">
                                        {{ participantInfo.participantNames[0] }}
                                        @if (participantInfo.isSingleContestant) {
                                            <span class="participant-country">{{ participantInfo.participant.country }}</span>
                                        }
                                        @if (!participantInfo.isSingleContestant) {
                                            <div class="second-participant">
                                                {{ participantInfo.participantNames[1] }}
                                            </div>
                                        }
                                    </div>
                                } @else {
                                    <div class="participant-details">
                                        <div class="participant-info">
                                            @if (!!participantInfo.rank) {
                                                <div class="participant-rank">{{ participantInfo.rank }}</div>
                                            }
                                            <div #tooltipContent class="participant" [class.highlight]="shouldHighlight(participantInfo.participant)">
                                                {{ participantInfo.participantNames[0] }}
                                                @if (
                                                    participantInfo.isSingleContestant && !participantInfo.winLossStats && !participantInfo.pitcher
                                                ) {
                                                    <span class="participant-country">{{ participantInfo.participant.country }}</span>
                                                }
                                                @if (!participantInfo.isSingleContestant) {
                                                    <div class="second-participant">
                                                        {{ participantInfo.participantNames[1] }}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        @if (!event.live) {
                                            <div class="betradar-stats">
                                                @if (!!participantInfo.winLossStats) {
                                                    <div class="win-loss-stats">
                                                        {{ participantInfo.winLossStats }}
                                                    </div>
                                                }
                                                @if (!!participantInfo.pitcher) {
                                                    <div class="pitcher-name">
                                                        {{ participantInfo.pitcher }}
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </ng-template>
                            @if (showRedCardsInSoccer) {
                                <div class="participant-details">
                                    <ng-container *ngTemplateOutlet="participant" />
                                    <div class="participant-penalty-cards">
                                        @for (redCard of participantInfo.redCards; track redCard) {
                                            <span class="red-card"></span>
                                        }
                                    </div>
                                </div>
                            } @else {
                                <ng-container *ngTemplateOutlet="participant" />
                            }
                            @if (showAwayIndicator(participantInfo.participant)) {
                                <span class="away-indicator" [msAutomation]="'grid-away-indicator'">
                                    {{ sitecore.globalMessages.AwayIndicator }}
                                </span>
                            }
                        </div>
                        @if (event.fixtureForm) {
                            <ms-fixture-form [event]="event" [participantType]="participantInfo.participant.type" />
                        }
                    </div>
                }
            </div>
        </ms-inline-tooltip>
    }
    @case ('Tournament') {
        <ms-inline-tooltip>
            <div #tooltipContent class="participants-tournament-game">
                <div class="tournament">{{ event.name }}</div>
                @if (leader) {
                    <div class="tournament tournament-leader">
                        1. {{ participantInfos[0].participantNames[0] }}
                        @if (participantInfos[0].isSingleContestant) {
                            <span class="participant-country">{{ participantInfos[0].participant.country }}</span>
                        }
                        @if (!participantInfos[0].isSingleContestant) {
                            <div class="second-participant">
                                {{ participantInfos[0].participantNames[1] }}
                            </div>
                        }
                    </div>
                }
            </div>
        </ms-inline-tooltip>
    }
    @case ('LeaderboardGame') {
        <ms-inline-tooltip>
            <div class="leaderboard-game">
                <div #tooltipContent class="event-name">{{ event.name }}: {{ event.league.name }}</div>
            </div>
        </ms-inline-tooltip>
    }
    @case ('Combi') {
        <ms-inline-tooltip>
            <div #tooltipContent class="participants-combi-game">
                <div class="combi-league combi-league-name">{{ event.name }}</div>
                <div class="combi-league combi-league-option">{{ option }}</div>
            </div>
        </ms-inline-tooltip>
    }
}
